import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

const script = () => {
	// Front-page hero slider
	new Swiper(".front-page .hero .swiper-container", {
		autoplay: {
			delay: 5000,
		},
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
        speed: 1000,
	});

	// Front-page testimonial slider
	new Swiper(".front-page .testimonial .swiper-container", {
		pagination: {
			el: ".swiper-pagination",
			type: "fraction",
		},
		autoHeight: true, //enable auto height
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		autoplay: {
			delay: 10000,
		},
		allowTouchMove: false,
        speed: 1000,
	});
};

exports.script = script;
